import axios from 'axios';

const API_BASE_URL = 'https://api.hitkarihospital.com:5005'; // Make sure this matches your backend port

const api = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true, // Important for sending cookies (like patientToken)
});

// Interceptor to handle common errors or token expiry
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Unauthorized, potentially token expired or invalid
            console.error("Unauthorized: Token expired or invalid. Logging out.");
            // Here you might trigger a logout action from your AuthContext
            // (AuthContext can be imported or a global event could be dispatched)
            localStorage.removeItem('patientToken');
            localStorage.removeItem('patientId');
            // If using a context, you'd dispatch an action like:
            // window.dispatchEvent(new Event('logout-event'));
            window.location.href = '/patientlogin'; // Redirect to login page
        }
        return Promise.reject(error);
    }
);

export const checkUserExistence = (phone) => api.post('/check-user', { phone });
export const requestOtp = (mobile) => api.post('/request-otp', { mobile });
export const verifyOtp = (mobile, otp) => api.post('/api/verify-otp', { mobile, otp });
export const getPatientAppointments = (patientId) => api.get(`/api/patients/${patientId}/appointments`);

export default api;